<!--关于我们-->
<template>
  <div class="about-container" :style="'min-height:'+min_height+'px;'">
    <div class="about-content">
      <p class="title SourceHanSansCN">关于我们</p>
      <div class="about-content-info" v-html="aboutInfo.content"/>
      <div class="about-address">总部地址：<span>{{aboutInfo.address}}</span></div>
      <div class="about-mobile">客服电话：<span>{{aboutInfo.mobile}}</span></div>
      <div class="about-email">电子邮箱：<span>{{aboutInfo.email}}</span></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "aboutUs",
  data(){
    return{
      aboutInfo:{
        content:'是帮企集团旗下的企业一站式综合服务平台，通过线上与线下相结合的方式，为中小企业提供一站式企业服务、融资服务、项目服务、上云服务、培育辅导服务、人才招聘服务、综合业务等为一体的综合性服务。服务项目涵盖从企业初创到上市转型全生命周期的所有服务。',
        address:'北京市朝阳区朝外雅宝路12号22层220825',
        mobile:'023-966500',
        email:'lg048@163.com',
      },
      min_height: document.documentElement.clientHeight - 396,
    }
  }
}
</script>

<style scoped lang="scss">
.about-container{
  background: #ffffff;
  padding: 20px 30px;
  .about-content{
    .title{
      margin-block-start: 0px;
      font-size: 16px;
      color: #333333;
      padding-bottom: 20px;
    }
    .about-content-info{
      font-size: 14px;
      color: #333333;
      line-height: 25px;
      font-family: 'SourceHanSansCN';
    }
    .about-address{
      color: #333333;
      padding-top: 70px;
      font-family: 'SourceHanSansCN';
      line-height: 25px;
      font-size: 14px;
      span{
        cursor: pointer;
      }
    }
    .about-mobile{
      color: #333333;
      font-family: 'SourceHanSansCN';
      line-height: 25px;
      font-size: 14px;
      span{
        cursor: pointer;
      }
    }
    .about-email{
      color: #333333;
      font-family: 'SourceHanSansCN';
      line-height: 25px;
      font-size: 14px;
      span{
        cursor: pointer;
      }
    }
  }
}
</style>